import { SBRMFormActionProps } from '@supplement-bacon/sbrm-react'
import { Form, Input, Result } from 'antd'
import { useEffect } from 'react'
import { useAppSelector } from '../../../../store/hooks'
import { selectSelectedFormQuestion } from '../../../../store/membership/FormQuestionReducer'

const Delete = ({ form, formProps }: SBRMFormActionProps) => {
  const item = useAppSelector(selectSelectedFormQuestion())

  useEffect(() => {
    form.setFieldsValue(item)
  }, [item])

  if (!item) {
    return <></>
  }

  return (
    <Form {...formProps} form={form} layout="vertical">
      <Result
        title={'Are you sure ?'}
        subTitle={
          'Deleting this resource will also delete all resource associated. This action is immediate and cannot be undone.'
        }
      />
      <Form.Item
        name="id"
        hidden
        required
        rules={[]}
        noStyle
        className="d-none"
      >
        <Input type="hidden" />
      </Form.Item>
    </Form>
  )
}

export default Delete
